import React, { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { loginService } from "../services/login";
import HeaderPublic from "./HeaderPublic";
import FooterPublic from "./FooterPublic";
import RadarBackground from "./RadarBackground";
import { useAuth } from "../contexts/AuthContext";
import "./Login.css";

const Login = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await loginService.login(credentials.email, credentials.password);

      login(data.user);

      // Back to the page that sent them to log in, if there was one,
      // otherwise the inventory.
      const from = location.state?.from;
      const target =
        from?.pathname && !["/", "/login"].includes(from.pathname)
          ? `${from.pathname}${from.search || ""}`
          : "/inventory";

      navigate(target, { replace: true });
    } catch (err) {
      setError(err.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <HeaderPublic />

      <div className="login-page">
        <RadarBackground />

        <div className="login-container">
          <div className="login-box">
            <div className="login-logo">
              <img
                src="/admongrel-mark.webp"
                alt="admongrel"
                className="logo-img"
              />
            </div>

            <form onSubmit={handleSubmit} className="login-form">
              {error && <div className="error-msg">{error}</div>}

              <label htmlFor="email">Username</label>
              <input
                id="email"
                type="email"
                name="email"
                autoComplete="username"
                value={credentials.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />

              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                name="password"
                autoComplete="current-password"
                value={credentials.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
              />

              <button type="submit" disabled={loading}>
                {loading ? "Signing in..." : "SUBMIT"}
              </button>

              <Link to="/forgot-password" className="login-forgot">
                Forgot your password?
              </Link>
            </form>
          </div>
        </div>
      </div>

      <FooterPublic />
    </>
  );
};

export default Login;
